import React from "react";

export const BStarIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 50 60"
      width="35"
      height="35"
    >
      <path
        d="M 23 15 L 19 24 L 7 31 L 18 37 L 23 48 L 27 38 L 40 31 L 30 27 Z"
        fill="#000"
      />
      <path
        d="M 39 10 L 36 14 L 32 15 L 37 19 L 38 22 L 39 19 L 44 16 L 39 12 Z"
        fill="#000"
      />
    </svg>
  );
};

export const SearchIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#fff"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="11" cy="11" r="7"></circle>
      <line x1="16.65" y1="16.65" x2="21" y2="21"></line>
    </svg>
  );
};

export const SearchIcon2 = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 24 24"
      fill="none"
      stroke="#F05A2A"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <circle cx="11" cy="11" r="7"></circle>
      <line x1="16.65" y1="16.65" x2="21" y2="21"></line>
    </svg>
  );
};

interface BackIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}
export const BackIcon: React.FC<BackIconProps> = ({
  size = 24,
  color = "#F05A2A",
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M10 19l-7-7 7-7" />
      <path d="M3 12h38" />
    </svg>
  );
};

export const ExpandIcon = ({ open }: { open: boolean }) => {
  return (
    <svg
      viewBox="0 0 24 24"
      width="24"
      height="24"
      style={{
        transform: open ? "rotate(180deg)" : "rotate(0deg)",
        transition: "0.3s",
      }}
    >
      <path
        d="M6 9l6 6 6-6"
        stroke="#00000070"
        strokeWidth="2"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

interface StoreIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export const StoreIcon: React.FC<StoreIconProps> = ({
  size = 24,
  color = "#F05A2A",
  strokeWidth = 4,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width={size}
      height={size}
      fill="none"
      aria-hidden="true"
    >
      <path
        d="M9 26L13 14H51L55 26H9Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 26V50H52V26"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22 34V50H42V34H22Z"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 26C9 30 12 33 16 33C20 33 23 30 23 26"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M23 26C23 30 26 33 30 33C34 33 37 30 37 26"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M37 26C37 30 40 33 44 33C48 33 51 30 51 26"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

interface UserIconProps {
  size?: number;
  color?: string;
  strokeWidth?: number;
}

export const UserIcon: React.FC<UserIconProps> = ({
  size = 24,
  color = "currentColor",
  strokeWidth = 2,
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      aria-hidden="true"
    >
      <circle cx="12" cy="8" r="4" stroke={color} strokeWidth={strokeWidth} />
      <path
        d="M4 20c0-3.6 3.6-6 8-6s8 2.4 8 6"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
